import { useState, memo, useEffect } from "react";
import usePrint from "hook/usePrint";
import RecordHistoryCustomerPDFForm from "component/form/RecordHistoryCustomerPDFForm";
import { useQuery } from "react-query";
import nursingCareRecordApi from "api/admin/nursingCareRecord";
import { getCookie } from "utils";
import { RootState } from "store";
import { useSelector } from "react-redux";
import dayjs, { Dayjs } from "dayjs";

interface IPrintPdfNursingProps {
  nurseId?: number | string | "";
  patientId: number | "";
  tab?: "staff" | "patient";
  setIsPrinting: React.Dispatch<React.SetStateAction<boolean>>;
  setParamsHistory: React.Dispatch<React.SetStateAction<{
    patientId: number | "";
    nurseId: number | "";
    id: number | "";
} | null>>
  currentDate?: Dayjs;
}
const PrintPdfNursingCareRecord = ({
  nurseId,
  patientId,
  setIsPrinting,
  setParamsHistory,
  currentDate,
  tab
}: IPrintPdfNursingProps) => {
  const user = useSelector((state: RootState) => state.user);
  const idToken = getCookie("access_token");
  const [dataPrint, setDataPrint]: any = useState(null);
  const [isReadyPrint, setIsReadyPrint] = useState(false)
  const { ref, handlePrint } = usePrint(true);
  const [filter] = useState({
    patient_id: patientId,
    start_date: dayjs(currentDate).startOf("month").format("YYYY-MM-DD"),
    end_date: dayjs(currentDate).endOf("month").format("YYYY-MM-DD"),
    care_plan_type: "",
    tab: tab || "staff",
    nurse_id: nurseId,
    page: "",
    per: "",
    sortKey: "",
    order: "",
    is_pdf: true,
  });


  const { isLoading, isFetching } = useQuery(
    ["nursing_care_histories", nurseId],
    () => 
      nursingCareRecordApi.getNursingCareHistory(idToken, filter, user?.role),  
    {
      onSuccess: async (data) => {
        try {
          setDataPrint(data.serialized_nursing_care_histories);
        } catch (error) {
          setIsPrinting(false);
          setParamsHistory(null);
          console.error(error);
        }
      },
      onError: async (error) => {
        setIsPrinting(false);
        setParamsHistory(null);
        console.error(error);
      },
    }
  );

  useEffect(() => {
    if (dataPrint && !isLoading && !isFetching && isReadyPrint) {
      handlePrint();
      setIsPrinting(false);
      setDataPrint(null);
      setParamsHistory(null);
    }
  }, [dataPrint, isLoading, isFetching, isReadyPrint]);

  return (
    <div>
      <RecordHistoryCustomerPDFForm
        ref={ref}
        dataPrint={dataPrint}
        setIsReadyPrint={setIsReadyPrint}
      />
    </div>
  );
};

export default memo(PrintPdfNursingCareRecord);
